<template>
  <div class="addr-box">
    <div>
      <van-form :show-error-message="false" validate-trigger="onChange" @submit="submit" @failed="failed">
        <van-cell-group inset :border="false">

          <!-- <div class="input-box" style="margin-top:20px;" @click="handleOpenSearch">
            <van-field
              :value="mapCenterInfo.detailedAddress"
              name=""
              placeholder=""
              class="input"
              disabled
            />
            <span style="font-size:12px;color:#4776E3;flex-shrink:0;padding-right:16px;">更改</span>
          </div> -->
          <div class="title-info flex-sb" @click="handleOpenSearch">
            <div style="flex: 1;overflow: hidden;">
              <div class="address-title">{{ mapCenterInfo.title }}</div>
              <div class="details-address">{{mapCenterInfo.detailedAddress}}</div>
            </div>
            <div class="update-address-btn">
              更改地址
              <i class="iconfont icon-qianjin" style="font-size: 10px;color: #C9C2BB;margin-left: 2px;"></i>
            </div>
          </div>
          <div class="input-box">
            <van-field
              v-model.trim="form.remark"
              label="详细地址"
              name="详细地址"
              placeholder="如：1栋2206"
              class="input"
              :rules="[{ validator: specialCharacterValid, message: '不支持空格及特殊符号' , trigger:'onChange' }]"
              clearable 
              @blur="formChange"
            />
          </div>
          <div class="input-box">
            <van-field
              v-model.trim="form.realName"
              label="联系人"
              name="姓名"
              placeholder="姓名"
              class="input"
              style="width:348px;"
              :rules="[
                { required: true, message: '请填写姓名' },
                { pattern: /^(([a-zA-Z+\.?\·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$))/, message: '请填写正确的姓名' },
              ]"
              clearable 
              @blur="formChange"
            />
            <van-field
              v-model.trim="form.phoneNumber"
              name="手机/座机"
              :placeholder="queryParams.autoCar&&queryParams.autoCar==1?'手机' : '手机/座机'"
              class="input"
              :rules="validatorPhone"
              clearable 
              @input="formChange"
            />
          </div>
        </van-cell-group>
        <div class="footer">
          <div 
            class="checkbox-group" 
            v-if="['homeStart','homeEnd'].includes(queryParams.pagesType) ||
            (isShowAddr && ['userAddressBookAdd','userAddressBookEdit'].includes(queryParams.pagesType))"
          >
            <!-- <van-checkbox 
            v-model="form.usualAddress" 
            checked-color="#F1892E" 
            icon-size="14px" 
            v-if="['homeStart','homeEnd','usualStart','usualEnd','editUsualStart','editUsualEnd'].includes(queryParams.pagesType)" 
            @change="checkboxChange"
            >存入常用地址</van-checkbox> -->
            <van-checkbox 
            v-model="form.usualAddress" 
            checked-color="#F1892E" 
            icon-size="14px" 
            v-if="['homeStart','homeEnd'].includes(queryParams.pagesType)" 
            @change="checkboxChange"
            >存入常用地址</van-checkbox>
            <!-- <van-checkbox 
              v-model="form.selected" 
              checked-color="#F1892E" 
              icon-size="14px" 
              v-if="['userAddressBookAdd','userAddressBookEdit'].includes(queryParams.pagesType)"
              @change="checkboxChange"
            >设为默认地址</van-checkbox> -->
            <div style="height: 6px;"></div>
            <div v-if="isShowAddr">
              <van-checkbox 
                v-model="form.save"
                checked-color="#F1892E" 
                icon-size="14px" 
                v-if="['userAddressBookAdd','userAddressBookEdit'].includes(queryParams.pagesType)"
                @change="checkboxChange"
              >存入地址簿</van-checkbox>
            </div>
          </div>
          <van-button 
            round 
            type="warning" 
            native-type="submit" 
            class="footer-button"
            :disabled="!mapLoaded||getCenterLoading"
          >{{submitName}}</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { Image , Field , Cell , CellGroup , Form , Button , Toast , Checkbox, CheckboxGroup  } from 'vant';
export default {
  name:'dispatch-address-info',
  inject: ["searchHistoryRecordAdd"],
  props:['mapCenterInfo','openSearch','isUserType','isShowAddr','queryParams','mapLoaded','getCenterLoading','isSwitchTab','checkAddressObject'],
  components:{ 
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
   },
  data(){
    return {
      form:{
        realName:'',
        phoneNumber:'',
        remark:'',
        save:''
      },
      validatorPhone:[]
    }
  },

  watch:{
    queryParams:{
      handler(val){
        this.form = this.deepClone(val)
      },
      deep:true,
      immediate:true
    }
  },
  computed:{
    submitName(){
      if(['homeStart','usualStart','editUsualStart'].includes(this.queryParams.pagesType)) return '确认装货地址';
      else if(['homeEnd','usualEnd','editUsualEnd'].includes(this.queryParams.pagesType)) return '确认卸货地址';
      else if(this.queryParams.pagesType === 'userAddressBookAdd') return this.queryParams.type === 'start'?'新增装货地址':this.queryParams.type === 'end'?'新增卸货地址':'新增地址';
      else if(this.queryParams.pagesType === 'userAddressBookEdit') return this.queryParams.type === 'start'?'修改装货地址':this.queryParams.type === 'end'?'修改卸货地址':'修改地址';
      else return '确认';
    }
  },
  created(){;
    if(this.queryParams.autoCar && this.queryParams.autoCar == 1){
      // 无人车填写手机号只能填写手机号
      this.validatorPhone = [
        { required: true, message: '请填写手机/座机' },
        { pattern: /^1[3456789]\d{9}$/,message: '请填写正确的手机' },
      ]
    }else{
      this.validatorPhone = [
        { required: true, message: '请填写手机/座机' },
        { pattern:/^((0\d{2,3}-\d{7,8})|(1\d{10})|(\d{7,8}))$/,message: '请填写正确的手机/座机' },
      ]
    }
    
  },
  methods:{
    /* 特殊字符校验 */
    specialCharacterValid(val){
      // return Promise.resolve(!/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、\s]/im.test(val))
      return Promise.resolve(!/[`~!@#$%^&*_+=<>?:"{}|.\/;'\\[\]·~！@#￥%……&*——+={}|《》？：“”【】、；‘'。、\s]/im.test(val))
    },
    checkboxChange(value){
      this.formChange();
    },
    formChange(){
      this.$emit('update:queryParams',{
        ...this.queryParams,
        ...this.deepClone(this.form)
      })
    },
    handleOpenSearch(){
      this.$emit('update:openSearch',true);
    },
    submit(){
      // 判断是否是普通用户
      if(this.isUserType){
        this.searchHistoryRecordAdd({
          historyRecord: "getQueryParams",
          item: {
            ...this.queryParams,
            address: this.queryParams.detailedAddress,
            location: {
              lat: this.queryParams.latitude,
              lng: this.queryParams.longitude
            }
          },
        });
        // 判断是否是修改卸货地，如果是修改卸货地的，直接跳回应用计算价格，否则就返回上一页
        if(this.isSwitchTab){
          // 判断传进来的参数是否与原卸货地一致，如果是同一卸货地，就不能跳转回应用
          if(this.checkAddressObject.province == this.queryParams.province && this.checkAddressObject.city == this.queryParams.city && this.checkAddressObject.title == this.queryParams.title
          && this.checkAddressObject.detailedAddress == this.queryParams.detailedAddress){
            return Toast('该卸货地与原卸货地重复，请重新修改卸货地！')
          }else{
            // this.searchHistoryRecordAdd({ item: this.queryParams , historyRecord: "getQueryParams" });
            window.uni.postMessage({ data: this.queryParams });
            window.uni.navigateTo({ url: '/packOrder/dispatch-address/index' });
          }
        }else{
          window.uni.postMessage({ data: this.queryParams });
          window.uni.navigateBack({ delta:1 });
        }
      }else{
        // vip下单判断必须要在同一个省
        if(this.checkAddressObject.province && this.checkAddressObject.province != this.queryParams.province){
          return Toast('仅支持同省多点装卸！')
        }
        window.uni.postMessage({
          data: this.queryParams
        });
        window.uni.navigateBack({
          delta:1
        })
      }

     
    },
    failed({ errors }){
      Toast.fail(errors[0].message);
    },
  }
}
</script>

<style scoped lang="scss">
  .addr-box {
      box-sizing: border-box;
      position: relative;
      z-index: 99;
      background-color: #FFEAD8;
      & > div {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding: 0 22px;
        background-color: #FFF;
        overflow: hidden;
      }
      * {
        color: #130A01;
      }
      .van-form {
        position: relative;
        z-index: 100000;
        .van-cell-group {
          margin: 0;
        }
        .title-info {
          overflow: hidden;
          padding: 12px 16px;
          margin: 16px 0;
          background-color: #F8F8F8;
          .details-address {
            font-size: 12px;
            line-height: 20px;
            color: #85807B;
          }
          .address-title {
            font-size: 18px;
            font-weight: bold;
            line-height: 26px;
            color: #3D3833;
          }
          .update-address-btn {
            flex-shrink: 0;
            margin-left: 13px;
            height: 24px;
            background-color: #FFF;
            border-radius: 2px;
            overflow: hidden;
            border: 1px solid #F5F1EF;
            font-size: 12px;
            line-height: 24px;
            padding: 0 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            counter-reset: #3D3833;
          }
        }
        .group-addr {
          padding: 0;
          width: auto;
          ::v-deep .van-radio__label {
            font-size: 14px;
            line-height: 30px;
          }
        }
        .input-box {
          height: 36px;
          overflow: hidden;
          background-color: #F5F5F5;
          border-radius: 6px;
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          ::v-deep .van-field__body {
            height: 100%;
          }
          .input {
            background-color: #F5F5F5;
            height: 36px;
            font-size: 16px;
          }
        }
        .footer {
          margin-bottom: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .footer-button {
            flex: 1;
            height: 44px;
            padding: 0 24px;
            background: #EC892E;
            border-radius: 4px;
            font-size: 16px;
            user-select: none;
            line-height: 44px;
            .van-button__text {
              font-family: 'DIN-Medium';
              color: #FFF;
            }
          }
          .checkbox-group + .footer-button {
            flex: none;
          }
        }
      }
    }
    ::v-deep .van-field {
      align-items: center;
      .van-field__label {
        width: auto;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        color: #1E1E1E;
      }
      .van-field__value {
        font-size: 16px;
        line-height: 24px;
      }
    }
  ::v-deep .van-hairline--top-bottom {
    &:after {
      border: none;
    }
  }
  ::v-deep .van-checkbox {
    .van-checkbox__label {
      font-size: 13px;
      color: #130A01;
    }
  }
  ::v-deep .van-field__control:disabled {
    color: #333 !important;
    -webkit-text-fill-color:#333 !important;
  }
</style>